import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
//Constants
import {API_WEB_URLS} from '../constants/constAPI';
import * as base_acTypes from './actionTypes';
/** Common Functions **/
//Change state value
export const Fn_ChangeStateValue = (obj, name, value) => {
    obj.setState({[name]: value});
};

export const Fn_FillListData = (obj,gridName,apiURL) => {
    return new Promise((resolve, reject) => {
        const request = {
            apiURL: apiURL,
            callback: (response) => {
                if (response && response.status === 200 && response.data) {
                    obj.setState({
                        [gridName]: response.data.dataList,
                        isProgress : false
                    })

                    if (gridName  ==  "PlyPartyH"){
                        obj.setState({
                            IsCalculated: response.data.dataList[0].Calculated == true ? true : false 
                        })   
                    }
                    resolve(response.data.dataList);
                } else {
                    showToastWithCloseButton("error", "Some error occurred while displaying grid data");
                    reject(new Error("Failed to fetch grid data"));
                }
            },
        };
        obj.props.callFill_GridData(request)
    });
};

export const Fn_GetReport = async (obj, data, apiURL, gridName, isMultiPart = false) => {
    const { arguList } = data;
  
    return new Promise((resolve, reject) => {
      const request = {
        arguList: arguList,
        apiURL: apiURL,
        callback: (response) => {
          if (response && response.status === 200 && response.data) {
            if (gridName === "productData") {
              obj.setState({
                [gridName]: response.data.response,
                rows: [Object.keys(response.data.response[0])],
                isProgress: false,
              });
            } else {
              obj.setState({
                [gridName]: response.data.response,
                isProgress: false,
              });
            }
  
            resolve(response.data.response); // ✅ resolve with data
          } else {
            obj.setState({
              [gridName]: [],
              isProgress: false,
            });
            showToastWithCloseButton("warning", "Data not found.");
            reject(new Error("No data found")); // ❌ reject with error
          }
        },
      };
  
      obj.props.callAdd_Data_Multipart(request);
    });
  };
  

export const Fn_FillListDataLedger = (obj,gridName,apiURL) => {
    const request = {
        apiURL: apiURL,
        callback: (response) => {
            if (response && response.status === 200 && response.data) {
                obj.setState({
                    [gridName]: response.data.dataList,
                    isProgress : false,
                    Name :response.data.dataList[0].Name,
                    GSTIN :response.data.dataList[0].GSTNo,
                    PhoneNo :response.data.dataList[0].Phone,
                    Mobile :response.data.dataList[0].Mobile,
                    Email :response.data.dataList[0].Email,
                    Address1 :response.data.dataList[0].Address1,
                    Address2 :response.data.dataList[0].Address2,
                    ZIP :response.data.dataList[0].Zip,
                    CountryId :response.data.dataList[0].F_CountryMaster,
                    StateId :response.data.dataList[0].F_StateMaster,
                    CityId :response.data.dataList[0].F_CityMaster,
                    LedgerGroupIds :response.data.dataList[0].F_LedgerGroupMaster
                },
                )
            } else {
                showToastWithCloseButton("error", "Some error occurred while displaying grid data");
            }
        },
    };
    obj.props.callFill_GridData(request)
};


export const Fn_FillListDataGlobal = (obj,gridName,apiURL) => {
    const request = {
        apiURL: apiURL,
        callback: (response) => {
            if (response && response.status === 200 && response.data) {
                obj.setState({
                    [gridName]: response.data.dataList,
                    VoucherNo :response.data.dataList[0].VoucherNo,
                    isProgress : false
                },
                )

                if (response.data.dataList[0].IsVoucherNoEnable == true){
                    obj.vdate.current.focus();
                }
                else {
                    obj.vno.current.focus();
                }
            } else {
                showToastWithCloseButton("error", "Some error occurred while displaying grid data");
            }
        },
    };
    obj.props.callFill_GridData(request)
};




export const Fn_FillListData2 = (obj,gridName,apiURL) => {
    return new Promise((resolve, reject) => {
        const request = {
            apiURL: apiURL,
            callback: (response) => {
                if (response && response.status === 200 && response.data) {
                    obj.setState({
                        [gridName]: response.data.dataList,
                        isProgress : false,
                        VoucherNo : response.data.dataList[0].VoucherNo,
                        VoucherDate : response.data.dataList[0].VoucherDate,
                        ChallanNo : response.data.dataList[0].ChallanNo,
                        ChallanDate : response.data.dataList[0].ChallanDate,
                        PONo : response.data.dataList[0].PONo,
                        PODate : response.data.dataList[0].PODate,
                        LedgerId : response.data.dataList[0].F_LedgerMaster,
                        SalesLedgerId : response.data.dataList[0].F_LedgerMasterSales,
                        Transport : response.data.dataList[0].Transport,
                        GRRNo : response.data.dataList[0].GRRNo,
                        GRRDate : response.data.dataList[0].GRRDate,
                        VehicleNo : response.data.dataList[0].VehicleNo,
                        Through : response.data.dataList[0].Through,
                        Signatory : response.data.dataList[0].Signatory,
                        IsDiff : response.data.dataList[0].DifferentConsignee,
                        GrossAmount : response.data.dataList[0].GrossAmount,
                        TaxAmount : response.data.dataList[0].TaxationAmount,
                        NetAmount : response.data.dataList[0].NetAmount,
                        F_LedgerMaster : response.data.dataList[0].F_LedgerMaster,
                        RoundedValue : response.data.dataList[0].RoundedValue,
                        IsDiff : response.data.dataList[0].IsDiff,
                        Add1 : response.data.dataList[0].Unit1,
                        Add2 : response.data.dataList[0].Unit2,
                        Add3 : response.data.dataList[0].Unit3,
                        IsCRN : response.data.dataList[0].IsCRN,
                        IsDBN : response.data.dataList[0].IsDBN
                    });

                    // Call the additional functions
              
                    Fn_FillListData5(obj , response.data.dataList[0].F_LedgerMaster , "");
                    Fn_FillListData(obj, "PlyPartyH", API_WEB_URLS.MASTER + "/0/token/PlyPartyH/Id/"+response.data.dataList[0].F_LedgerMaster);

                    if (response.data.dataList[0].IsCancelled == true){
                        obj.setState({canceleinvoiceBtn : true , cancelinvoiceName : 'Already Cancelled!'})
                    }
                    else {
                        obj.setState({canceleinvoiceBtn : false, cancelinvoiceName : 'Cancel Invoice' })
                    }

                    if (response.data.dataList[0].Irn != null){
                        obj.setState({edit : true , editbtnname : 'Cant Edit!', einvoice : true})
                    }
                    else {
                        obj.setState({edit : false , editbtnname : 'EDIT', einvoice : false })
                    }

                    if (response.data.dataList[0].IsDiff == true){
                        obj.setState({ 
                            IsCon : false
                        })
                    }

                    resolve(response.data.dataList); // Resolve with the data
                } else {
                    showToastWithCloseButton("error", "Some error occurred while displaying grid data");
                    reject(new Error("Failed to fetch grid data")); // Reject with error
                }
            },
        };

        obj.props.callFill_GridData(request)
    });
};








export const Fn_FillListData3 = (obj,F_LedgerMaster,apiURL) => {
    
    var Name  =  "Ply"
 



    const request2 = {
        apiURL: "Masters/0/token/GetItemByPlyPartyDescription/Id/"+F_LedgerMaster,
        callback: (response) => {
            if (response && response.status === 200 && response.data) {
                obj.setState({
                    [Name]: response.data.dataList
                },
               
                )
            } else {
                showToastWithCloseButton("error", "Some error occurred while displaying grid data");
            }
        },
    };

    obj.props.callFill_GridData(request2)
};






export const Fn_FillListDataInvoice = (obj,apiURL) => {
    
    var Name  =  "Invoice"
 



    const request2 = {
        apiURL: "Masters/0/token/Invoice/Id/0",
        callback: (response) => {
            if (response && response.status === 200 && response.data) {
                obj.setState({
                    [Name]: response.data.dataList
                },
               
                )
            } else {
                showToastWithCloseButton("error", "Some error occurred while displaying grid data");
            }
        },
    };

    obj.props.callFill_GridData(request2)
};






export const Fn_FillListData4 = (obj,F_LedgerMaster,apiURL) => {
    
    var Name  =  "PrintDesc"
 


    const request2 = {
        apiURL: "Masters/0/token/GetPrintPartyDescription/Id/"+F_LedgerMaster,
        callback: (response) => {
            if (response && response.status === 200 && response.data) {
                obj.setState({
                    [Name]: response.data.dataList
                },
               
                )
            } else {
                showToastWithCloseButton("error", "Some error occurred while displaying grid data");
            }
        },
    };

    obj.props.callFill_GridData(request2)
};






export const Fn_FillListData5 = (obj,F_LedgerMaster,apiURL) => {
    
    var Name  =  "ConsigneeAddress"
 


    const request2 = {
        apiURL: "Masters/0/token/LedgerConsigneeAddress/Id/"+F_LedgerMaster,
        callback: (response) => {
            if (response && response.status === 200 && response.data) {
                obj.setState({
                    [Name]: response.data.dataList
                },
               
                )

                if (obj.state.Add1 == true){
                    obj.setState({Add1 : true  , OtherAddress : response.data.dataList[0].Address1 , Add2:false , Add3 : false});
                  }
                  else if (obj.state.Add2 == true){
                    obj.setState({Add1 : false  , OtherAddress : response.data.dataList[0].Address2 , Add2:true , Add3 : false});
                  }
                  else if (obj.state.Add3 == true){
                    obj.setState({Add1 : false  , OtherAddress : response.data.dataList[0].Address3 , Add2:false , Add3 : true});
                  }
            } else {
                showToastWithCloseButton("error", "Some error occurred while displaying grid data");
            }
        },
    };

    obj.props.callFill_GridData(request2)
};




export const Fn_DisplayData = async (obj, id, apiURL) => {
    return new Promise((resolve, reject) => {
        const request = {
            id: id,
            apiURL: apiURL,
            callback: (response) => {
                if (response && response.status === 200 && response.data) {
                    obj.setState({
                        formData: response.data.dataList[0]
                    }, () => resolve(response.data.dataList[0])); // resolves after state is set
                } else {
                    showToastWithCloseButton("error", "Some error occurred while displaying data");
                    reject(new Error("Failed to fetch data"));
                }
            },
        };
        obj.props.callGet_Data(request);
    });
};



export const Fn_DisplayDataLedger = (obj,id,apiURL) => {
    const request = {
        id:id,
        apiURL: apiURL,
        callback: (response) => {
            if (response && response.status === 200 && response.data) {                
                obj.setState({
                    formData: response.data.dataList[0],
                    Name :response.data.dataList[0].Name,
                    GSTIN :response.data.dataList[0].GSTNo,
                    PhoneNo :response.data.dataList[0].Phone,
                    Mobile :response.data.dataList[0].Mobile,
                    Email :response.data.dataList[0].Email,
                    Address1 :response.data.dataList[0].Address1,
                    Address2 :response.data.dataList[0].Address2,
                    ZIP :response.data.dataList[0].Zip,
                    CountryId :response.data.dataList[0].F_CountryMaster,
                    StateId :response.data.dataList[0].F_StateMaster,
                    CityId :response.data.dataList[0].F_CityMaster,
                    LedgerGroupIds :response.data.dataList[0].F_LedgerGroupMaster
                })
                // if(apiURL===API_WEB_URLS.COMPANY)
                // {
                //     //Fill city drop down
                //     if(response.data.data[0].stateId && response.data.data[0].stateId>0)
                //         Fn_FillListData(obj,'lstCity',API_WEB_URLS.COMMON_GETLIST_DROPDOWN + '/cities/stateId/'+ response.data.data[0].stateId);
                // }
                // else if(apiURL===API_WEB_URLS.PROPERTY_FLOOR || apiURL===API_WEB_URLS.SUB_COMPANY)
                // {
                //     //Fill city drop down
                //     if(response.data.data[0].blockId && response.data.data[0].blockId>0)
                //         Fn_FillListData(obj,'lstBlock',API_WEB_URLS.COMMON_GETLIST_DROPDOWN + '/blocks/propertyId/'+ response.data.data[0].propertyId);
                // }
            } else {
                showToastWithCloseButton("error", "Some error occurred while displaying data");
            }
        },


        
    };
    obj.props.callGet_Data(request)
};

export const Fn_AddEditData = (obj, data, apiURL, pushFormName, isMultiPart=false, getid) => {    
    const { arguList } = data;
    return new Promise((resolve, reject) => {
        const request = {
            arguList: arguList,
            apiURL: apiURL,
            callback: (response) => {
                if (response && response.status === 200) {
                    obj.setState({
                        [getid]: response.data.data.id
                    });

                    console.log(response.data.data.id);

                    if (arguList.id === 0)
                        showToastWithCloseButton("success", "Data added successfully");
                    else
                        showToastWithCloseButton("success", "Data updated successfully");
                    
                    obj.props.history.push(pushFormName);
                    resolve(response.data);
                } else {
                    if (arguList.id === 0)
                        showToastWithCloseButton("error", "Some error occurred while updating data");
                    else
                        showToastWithCloseButton("error", "Some error occurred while updating data");
                    reject(new Error("Failed to add/edit data"));
                }
            },
        };
   
        if (arguList.id === 0) {
            if (isMultiPart) obj.props.callAdd_Data_Multipart(request);
            else obj.props.callAdd_Data(request);
        } else {
            if (isMultiPart) obj.props.callEdit_Data_Multipart(request);
            else obj.props.callEdit_Data(request);
        }
    });
};









export const Fn_AddEditDataH = (obj, data,apiURL,pushFormName,isMultiPart=false , getid , data1 , data2 , data3, data4) => {    
    const { arguList } = data;
    const request = {
        arguList: arguList,
        apiURL: apiURL,
        callback: (response) => {


            if (response && response.status === 200) {

                obj.setState({
                    [getid]: response.data.data.id,
                    InvoiceId : response.data.data.id,
                    success_msg : true,
                    save: true , einvoice : false ,  InvoiceSel : false , cancel : true  , add:false, print:false
                })
                Fn_FillListDataInvoice(obj  , "")
                if(data2.length > 0){
                let vformData2 = new FormData();
                vformData2.append("F_InvoiceMasterH", response.data.data.id);
                vformData2.append("Data", data2);

                Fn_AddEditData(obj, { arguList: { id: 0, formData: vformData2 } }, "InvoiceTax/0/token", "addinvoice", true);
                }
                if(data1.length > 0){
                let vformData = new FormData();
                vformData.append("F_InvoiceMasterH", response.data.data.id);
                vformData.append("Data", data1);
            

                Fn_AddEditData(obj, { arguList: { id: 0, formData: vformData } }, "InvoiceL/0/token", "addinvoice", true);
                }
                if(data4.length > 0){
                let vformData4 = new FormData();
                vformData4.append("F_InvoiceMasterH", response.data.data.id);
                vformData4.append("Data", JSON.stringify(data4));


                Fn_AddEditData(obj, { arguList: { id: 0, formData: vformData4 } }, "InvoiceTaxableAmount/0/token", "addinvoice", true);
                }   
                

                if (data3.length > 0) {


                    let vformData3 = new FormData();
                    
                     vformData3.append("F_InvoiceMasterH", response.data.data.id);
                    vformData3.append("Data", JSON.stringify(data3));
                  
                    Fn_AddEditData(obj, { arguList: { id: 0, formData: vformData3 } }, "InvoiceCharge/0/token", "addinvoice", true);
                 
                 }

                
                if (arguList.id === 0)
                    showToastWithCloseButton("success", "Data added successfully");
                else
                    showToastWithCloseButton("success", "Data updated successfully");
                obj.props.history.push(pushFormName);
            } else {
                if (arguList.id === 0)
                    showToastWithCloseButton("error", "Same Invoice No. used!");
                else if (arguList.id == -1)
                showToastWithCloseButton("error", "Same Invoice No. used!");
                else
                    showToastWithCloseButton("error", "Same Invoice No. used");
            }
        },
    };
   
    if (arguList.id === 0)
 
        if (isMultiPart) obj.props.callAdd_Data_Multipart(request);
        else obj.props.callAdd_Data(request);
    else
        if (isMultiPart) obj.props.callEdit_Data_Multipart(request);
        else obj.props.callEdit_Data(request);
};







export const Fn_ChangePassword = (obj,data,apiURL,pushFormName,isMultiPart=false) => {    
    const { arguList } = data;
    const request = {
        arguList: arguList,
        apiURL: apiURL,
        callback: (response) => {

            if (response.data.response[0].Id>0) {
                if (arguList.id === 0)
                    showToastWithCloseButton("success", "Password Changed Successfully");
                else
                    showToastWithCloseButton("success", "Data updated successfully");
                obj.props.history.push(pushFormName);
            } else {
                if (arguList.id === 0)
                    showToastWithCloseButton("error", "Old Password is wrong.");
                else
                    showToastWithCloseButton("error", "Some error occurred while updating data");
            }
        },
    };
   
    if (arguList.id === 0)
 
        if (isMultiPart) obj.props.callAdd_Data_Multipart(request);
        else obj.props.callAdd_Data(request);
    else
        if (isMultiPart) obj.props.callEdit_Data_Multipart(request);
        else obj.props.callEdit_Data(request);
};





export const Fn_UserLogin = (obj,data,apiURL,pushFormName,isMultiPart=false) => {    
  
    const { arguList } = data;
    const request = {
        arguList: arguList,
        apiURL: apiURL,
        callback: (response) => {
        
            if (response && response.status === 200) {
                if (arguList.id === 0)
                    showToastWithCloseButton("success", "Logged in successfully");
                else
                    showToastWithCloseButton("success", "Logged in successfully");
                obj.props.history.push(pushFormName);
            } else {
                if (arguList.id === 0)
                    showToastWithCloseButton("error", "UserName or Password Incorrect!");
                else
                    showToastWithCloseButton("error", "UserName or Password Incorrect!");
            }
        },
    };
  
    if (arguList.id === 0)
        if (isMultiPart) obj.props.callAdd_Data_Multipart(request);
        else obj.props.callAdd_Data(request);
    else
        if (isMultiPart) obj.props.callEdit_Data_Multipart(request);
        else obj.props.callEdit_Data(request);
};

export const Fn_DeleteData = (obj,id,apiURL,apiURL_Display) => {    
    return new Promise((resolve, reject) => {
        const request = {
            id:id,
            apiURL: apiURL,
            callback: (response) => {
                if (response && response.status === 200) {
                    obj.setState({
                        confirm_alert: false,
                        success_dlg: true,
                        dynamic_title: "Deleted",
                        dynamic_description: "Selected data has been deleted.",
                    })
                    showToastWithCloseButton("success", "Data deleted successfully");
                    if(apiURL_Display)                
                    Fn_FillListData(obj,'gridData',apiURL_Display);
                    Fn_FillListData(obj,'Invoice',apiURL_Display);
                    obj.add();
                    resolve(response.data);
                }
                else{
                    obj.setState({
                        confirm_alert: false,
                        dynamic_title: "Deleted",
                        dynamic_description: "Selected data has been deleted.",
                    })
                    showToastWithCloseButton("error", "Some error occurred while deleting data");
                    reject(new Error("Failed to delete data"));
                }
            },
        };
        obj.props.callDelete_Data(request);
    });
};

export const togglemodal = (obj,formData) => {
    obj.setState(prevState => ({
        modal: !prevState.modal,
        selectedFormData: formData ? formData : {}
    }));
}

export const toggleDeleteConfirm = (obj,formData,value) => {
    obj.setState({confirm_alert: value,
        selectedFormData: formData ? formData : {}
    });
}

export const toggleDeleteSuccess = (obj,value) => {
    obj.setState({success_dlg: value});
}

export function showToastWithCloseButton(toastType, message) {
    toastr.options = {
        closeButton: true,
        preventDuplicates: true,
        newestOnTop: true,
        progressBar: true,
        timeOut: 2000
    }
    if (toastType == "success")
        toastr.success(message);
    else if (toastType == "error")
        toastr.error(message);
}
/***/
